import styled from 'styled-components';
import { default as C } from '@assets/themes/colors';

interface IStyleProps {
  active?: boolean;
  bodyHeight?: number;
};

interface IGeneralProps {
  selected: boolean;
  isOver: boolean;
  level: number;
  pickerType: string;
  isDropping?: boolean;
  isShadow?: boolean;
  
};

interface ITypeProps {
  pickerType: string;
  locked: boolean;
};

interface IEditable{
  isEditable?: boolean;
}

export const CheckContainer = styled.div`
  width: 26px;
  padding-top: 5px;
`;

export const Root = styled.div`
  ${(props: ITypeProps) => (props.pickerType==="STACKS" && !props.locked ? "cursor: move;" : "cursor: pointer")}
`;

export const GeneralContainer = styled.div`
  display: flex;
  height: ${(props: IGeneralProps) => props.isShadow ? 10 : 26}px;
  flex-grow: 0;
  font-family: Roboto;
  align-items: center;
  padding-left: ${(props: IGeneralProps) => (15 + (props.level*8)).toString() + 'px;'};
  padding-right: 5px;
  ${(props: IGeneralProps) => (props.selected ? "background-color: rgba(18, 36, 66, 0.1);" : "")};
  ${(props: IGeneralProps) => (props.isOver ? "background-color: rgba(18, 36, 66, 0.1);" : "")};
  border: solid 0.5px transparent;
  border-bottom: solid 2px ${(props: IGeneralProps) => (props.isDropping ? '#204078':'transparent')};
`;

export const Title = styled.div`
  margin-left: 8px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: #122442;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 5px;
  padding-left: 2px;
  cursor: pointer;
  text-align: left;
  width: 100%;
  
`;

export const IconContainer = styled.div`
  padding-left: 5px;
`;

export const VisibilityIconContainer = styled.div`
  cursor: pointer;
`;

export const EditContainer = styled.input`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;  
  color: #122442;
  width: 95%;  
  border: 1px solid #204078;
  background-color: 'white';
  border-radius: 3px;
  outline: none !important;
`;